export var MuiSvgIcon = {
    root: {
        fontSize: '1em',
    },
};
//# sourceMappingURL=MuiSvgIcon.js.map